import { useState } from 'react';
import { useAppContext } from '../../context/AppContext';
import { useHunts } from '../../hooks/useHunts';
import styles from './NewHuntModal.module.css';

const HUNT_TYPES = [
  { type: 'numbers',  title: 'Numbers (1-100)', desc: 'A fixed grid of 100 numbers, filled in as you find them.' },
  { type: 'alphabet', title: 'Alphabet (A-Z)',  desc: 'A fixed grid of 26 letters, filled in as you find them.' },
  { type: 'custom',   title: 'Custom',          desc: 'Name your own hunt — the grid grows as you photograph new items.' },
];

export default function NewHuntModal() {
  const { dispatch } = useAppContext();
  const { createHunt } = useHunts();

  const [type, setType] = useState(null);
  const [title, setTitle] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  function close() {
    dispatch({ type: 'CLOSE_MODAL' });
  }

  async function handleCreate() {
    if (!type) return;
    if (type === 'custom' && !title.trim()) { setError('Give your hunt a title'); return; }
    setError('');
    setSaving(true);
    try {
      await createHunt({ type, title });
      close();
    } catch (err) {
      setError('Something went wrong. Try again.');
      console.error(err);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className={styles.backdrop} onClick={(e) => e.target === e.currentTarget && close()}>
      <div className={styles.panel}>
        <div className={styles.header}>
          <h2 className={styles.title}>New Hunt</h2>
          <button className={styles.closeBtn} onClick={close} aria-label="Close">✕</button>
        </div>

        <div className={styles.body}>
          <div className={styles.typeGroup}>
            {HUNT_TYPES.map(opt => (
              <label
                key={opt.type}
                className={`${styles.typeOption} ${type === opt.type ? styles.selected : ''}`}
              >
                <input
                  type="radio"
                  name="hunt-type"
                  value={opt.type}
                  checked={type === opt.type}
                  onChange={() => setType(opt.type)}
                  className={styles.hiddenInput}
                />
                <span className={styles.typeTitle}>{opt.title}</span>
                <span className={styles.typeDesc}>{opt.desc}</span>
              </label>
            ))}
          </div>

          {type === 'custom' && (
            <label className={styles.label}>
              Hunt title
              <input
                className={styles.input}
                type="text"
                value={title}
                onChange={e => setTitle(e.target.value)}
                placeholder="e.g. Manhole Covers"
                autoFocus
              />
            </label>
          )}

          {error && <p className={styles.error}>{error}</p>}

          <div className={styles.actions}>
            <button className={styles.cancelBtn} onClick={close}>Cancel</button>
            <button className={styles.createBtn} onClick={handleCreate} disabled={saving || !type}>
              {saving ? 'Creating…' : 'Create Hunt'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
